import { useEffect } from "react";

export const SITE_URL = "https://skazkidladetey.ru";
export const DEFAULT_TITLE =
  "Сказки детям на ночь — сказка с именем ребёнка и новая сказка каждый вечер";
export const DEFAULT_DESCRIPTION =
  "Персональная сказка с именем ребёнка за пару минут, первая бесплатно. И каждый вечер новая бесплатная сказка с озвучкой в MAX-канале.";

function setMeta(attr, name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setRobots(content) {
  setMeta("name", "robots", content || "index, follow");
}

function setJsonLd(data) {
  const id = "seo-jsonld";
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSeo({ title, description, path = "", image, jsonLd, noindex } = {}) {
  const finalTitle = title || DEFAULT_TITLE;
  const finalDescription = description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${path}`;
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = finalTitle;
    setMeta("name", "description", finalDescription);
    setCanonical(url);
    setRobots(noindex ? "noindex, follow" : "index, follow");
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", finalDescription);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", jsonLd ? "article" : "website");
    setMeta("property", "og:site_name", "Сказки детям на ночь");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", finalTitle);
    setMeta("name", "twitter:description", finalDescription);
    if (image) setMeta("name", "twitter:image", image);
    setJsonLd(jsonLdKey ? jsonLd : null);
    return () => setJsonLd(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalTitle, finalDescription, url, image, jsonLdKey, noindex]);
}
